import { getSpaceLimits } from "./index95.js";
import { positionModularSpaces } from "./index109.js";
import { getSpaceInsertionScore } from "./index111.js";
function insertModularSpaces(leanSpaces, sortedApartments, forceInvalid, dataset, levelId) {
	if (leanSpaces.length === 0) return {
		sortedApartmentsAndTechSpaces: sortedApartments,
		invalidSpaces: [],
		spacesAdded: []
	};
	const spaces = removeLengthWidthRequirements(leanSpaces);
	const scores = [];
	for (let i = 0; i < sortedApartments.length; i++) {
		scores.push([]);
		for (let j = 0; j < sortedApartments[i].length; j++) scores[i].push(getSpaceInsertionScore(spaces, sortedApartments, i, j));
	}
	const flatScores = scores.reduce((acc, row) => acc.concat(row), []);
	const minInvalid = Math.min(...flatScores.map((scores$1) => scores$1.invalid));
	const minArea = Math.min(...flatScores.filter((scores$1) => scores$1.invalid === minInvalid).map((scores$1) => scores$1.totalUnusedArea));
	let apartmentIndex = -1;
	const sectionIndex = scores.findIndex((row) => {
		apartmentIndex = row.findIndex((score) => score.invalid === minInvalid && score.totalUnusedArea === minArea);
		return apartmentIndex !== -1;
	});
	if (forceInvalid) {
		const { invalidSpaces } = positionModularSpaces(spaces, sortedApartments, dataset, sectionIndex, apartmentIndex, levelId);
		const altSpaces = [...spaces];
		for (const invalidSpace of invalidSpaces) {
			const leanSpace = {
				area: [getSpaceLimits({
					space: invalidSpace.space,
					includes: invalidSpace.includes
				}).area[0], 1e3],
				sizeX: [.1, 1e3],
				sizeY: [.1, 1e3],
				sizeZ: [.1, 1e3],
				space: invalidSpace.space,
				includes: invalidSpace.includes,
				invalidatedSize: true
			};
			const i = altSpaces.findIndex((space) => space.space === invalidSpace.space);
			altSpaces.splice(i, 1, leanSpace);
		}
		return insertModularSpaces(altSpaces, sortedApartments, false, dataset, levelId);
	} else return positionModularSpaces(spaces, sortedApartments, dataset, sectionIndex, apartmentIndex, levelId);
}
function removeLengthWidthRequirements(spaces) {
	return spaces.map((space) => Object.assign({}, space, {
		sizeX: [.1, 1e3],
		sizeZ: [.1, 1e3]
	}));
}
export { insertModularSpaces };

//# sourceMappingURL=index112.js.map